import { render } from "../../views/forms/form_items.html?vue&type=template&id=2ab5be72&ts=true&external"
import script from "../../scripts/forms/form_items.ts?vue&type=script&lang=ts&external"
export * from "../../scripts/forms/form_items.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/forms/form_items.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ab5be72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ab5be72', __exports__)) {
    api.reload('2ab5be72', __exports__)
  }
  
  module.hot.accept("../../views/forms/form_items.html?vue&type=template&id=2ab5be72&ts=true&external", () => {
    api.rerender('2ab5be72', render)
  })

}


export default __exports__